import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FileUploadService } from '../file-upload.service';
import { IFileStoreItem } from '../../../documents/interfaces/IFileStoreItem';
import { GapiServiceService } from '../../../services/gapi-service.service';
import { UserService } from '../../../services/user.service';
import { StorageType } from '../../../documents/enums/storageType';
import { GoogleFileInfo } from '../../../models/googleFileInfo';
import { GoogleBaseInfo } from '../../../models/googleBaseInfo';
import { FileStoreItem } from '../../../documents/models/FileStoreItem';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { HttpEventType } from '@angular/common/http';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit, OnChanges {

  storageType: string;
  errorMessage: string;
  private _safeUrl = null;
  public documentHtml: SafeHtml;
  constructor(
    private fileService: FileUploadService,
    private gapiService: GapiServiceService,
    private userService: UserService,
    private sanitizer: DomSanitizer
  ) {
    this.storageType = this.userService.getCurrentUser().storageType;
   }

  dropzoneActive: boolean;
  uploadValid = true;
  documentUrl: SafeResourceUrl = null;
  documentLink: string = null;
  public progress: number = null;
  get isGdrive(): boolean {
    return this.gapiService.isGoogle;
  }
  @Input() singeFile = true;
  @Input() hasPreview = true;
  @Input() thumbnail: string = null;
  @Input() multiFile = false;
  @Input() fileInfo: IFileStoreItem = null;
  @Input() container: string = null;
  @Input() partition: string = null;
  @Input() disabled = false;
  @Input() dropText = 'Drop file here';

  @Output() UploadedFile = new EventEmitter<IFileStoreItem>();
  @Output() UploadedFiles = new EventEmitter<IFileStoreItem[]>();

  ngOnInit() {
  }
  handleDrop(fileList: FileList) {
    this._safeUrl = null;
    if (this.singeFile && fileList.length === 1) {
      this.uploadValid = true;
    } else if (this.multiFile  && fileList.length > 0) {
      this.uploadValid = true;
    } else {
      this.uploadValid = false;
    }
    if (this.multiFile && this.uploadValid) {
      this.fileService.UploadMany(fileList).subscribe((result) => {
        this.UploadedFiles.emit(result);
        this.uploadValid = true;
      });
    } else if (this.singeFile && this.uploadValid) {
      if (this.storageType === StorageType.Google) {
        const gfile = new GoogleFileInfo();
        gfile.Blob = fileList[0];
        gfile.Name = fileList[0].name;
        this.gapiService.importFile(this.gapiService.appRootFolder.Id,
          gfile,
          (res: any) => this.onImportError(res),
          (res: any) => this.onImportComplete(res),
          (res: any) => this.onImportProgress(res));
      } else {
        this.fileService.UploadOne(fileList[0], this.container, this.partition).subscribe((result) => {
          if (result.type === HttpEventType.Response) {
            const file = <IFileStoreItem>result.body;
            this.UploadedFile.emit(file);
            this.progress = null;
            this.uploadValid = true;
          } else if (result.type === HttpEventType.UploadProgress) {
            const percentDone = Math.round(100 * result.loaded / result.total);
            this.progress = percentDone;
          }
        });
      }
    } else {
      setTimeout(() => {
        this.uploadValid = true;
      }, 700);
    }
  }
  dropzoneState(active: boolean) {
    this.dropzoneActive = active;
  }
  onImportError(res: string) {
    this.errorMessage = res;
  }
  onImportComplete(res: string) {
    if (res) {
      const fileInfo: GoogleBaseInfo = GoogleBaseInfo.fromGoogleFile(JSON.parse(res));
      this.gapiService.getFile(fileInfo.Id).then((fileResponse) => {
        const fileItem: IFileStoreItem = FileStoreItem.fromGoogleFileInfo(fileResponse);
        if (fileItem) {
          this.UploadedFile.emit(fileItem);
        }
      });
    }
  }
  onImportProgress(event: any) {
  }

  public setdocumentHtml(url: string, type: string) {
      this.documentHtml = this.sanitizer.bypassSecurityTrustHtml(
          '<object data=\'' + url + '\' type=\'' + type + '\' class=\'embed-responsive-item\'>' +
          'Object ' + url + ' failed' +
          '</object>');
  }
  get safeUrl(): SafeResourceUrl {
    const u = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileInfo.link);
    if (u !== this._safeUrl && this.fileInfo) {
      this._safeUrl = u;
    }
    return this._safeUrl;
  }
  ngOnChanges(changes: SimpleChanges) {
    let url: string = null;
    if (changes['fileInfo']) {
      if (this.gapiService.isGoogle) {
        if (this.fileInfo) {
          url = 'https://docs.google.com/viewer?srcid=' + this.fileInfo.id + '&pid=explorer&efh=false&a=v&chrome=false&embedded=true';
          this.documentUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(url);
        } else {
          this.documentUrl = null;
          this.documentLink = null;
        }
      } else {
        if (this.fileInfo) {
          url = this.fileInfo.link;
          if (url) {
            this.documentLink = url;
            this.documentUrl =  this.sanitizer.bypassSecurityTrustUrl(url);
            this.setdocumentHtml(this.fileInfo.link, this.fileInfo.contentType);
          }
        } else {
          this.documentUrl = null;
          this.documentLink = null;
        }
      }
    }
  }
}
